<app-mainscreen>
    <div class="view_box_container">
        <div class="">
            <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-8 col-12">
                    <div class="view_div">
                        <div class="row align-items-center justify-content-start">
                            <div class="w-auto">
                                <div class="view_block">
                                    <ul>
                                        <li>
                                            <div class="d-flex justify-content-between">
                                                <img class="img-fluid w-auto w-95px" title="{{insuranceFormControl['insuranceName'].value}}" alt="{{insuranceFormControl['insuranceName'].value}}" src="/assets/images/insurance_companies/{{insuranceFormControl['insuranceId'].value}}.png">
                                                <div class="text-center">
                                                    <label class="w-100 mb-0">Status</label>
                                                    <label class="w-auto mb-0 status" [ngClass]="insuranceFormControl['insuranceStatus'].value == false ? 'inactive' : 'active'"> {{insuranceFormControl['insuranceStatus'].value == false ? 'Inactive' : 'Active'}}</label>
                                                </div>
                                            </div>
                                            <p class="mb-0">{{insuranceFormControl['insuranceName'].value}}</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="view_buttons d-flex justify-content-end pt-0">
                        <app-custom-button className="bg-secondary" text="Back" [width]="'auto'" [height]="'34px'" leadingIconName="list" (click)="homeBtClick()">Back</app-custom-button>
                        <app-custom-button className="ml-2" text="Edit" [width]="'auto'" [height]="'34px'" leadingIconName="edit" (click)="backBtClick()" *ngIf="canEdit">Edit</app-custom-button> 
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="box_container mt-3"> 
        <div class="row w-100">
            <div class="col-md-4 border-right">
                <form id="kt_account_profile_details_form" class="form" [formGroup]="insuranceForm" novalidate="novalidate">
                    <div class="box_header pb-0">
                        <span class="box_title_18">
                            Provider Details
                        </span>           
                    </div>
                    <div class="p-lr-10">
                        <label class="box_title_18 border_top_grey5 w-100 mb-0 pb-2"></label>                
                        <div class="row">
                            <div class="col-12 position-relative" [ngClass]="{'mb-2':((insuranceFormControl['contactNumber'].touched  || submittedInsForm) && !insuranceFormControl['contactNumber'].valid)}">
                                <input type="text" id="contactNumber" name="contactNumber" placeholder=" " class="form-control input_ tp" formControlName="contactNumber" (keypress)="alphabetOnly($event)"
                                [ngClass]="{'border border-danger': ((insuranceFormControl['contactNumber'].touched  || submittedInsForm) && insuranceFormControl['contactNumber'].errors?.['required'])}"  [readOnly]="true">
                                <label for="contactNumber" class="label_">Contact Number</label>
                                <Span class="text-danger error_span" *ngIf="((insuranceFormControl['contactNumber'].touched  || submittedInsForm) && insuranceFormControl['contactNumber'].errors?.['required'])">
                                    Contact number is required.
                                </Span>
                            </div>
                            <div class="col-12 position-relative" [ngClass]="{'mb-2':((insuranceFormControl['email'].touched  || submittedInsForm) && !insuranceFormControl['email'].valid)}">
                                <input type="text" id="email" name="email" placeholder=" " class="form-control input_ tp" formControlName="email" (keypress)="alphabetOnly($event)"
                                [ngClass]="{'border border-danger': ((insuranceFormControl['email'].touched  || submittedInsForm) && insuranceFormControl['email'].errors?.['required'])}"  [readOnly]="true">
                                <label for="email" class="label_">Email Id</label>
                                <Span class="text-danger error_span" *ngIf="((insuranceFormControl['email'].touched  || submittedInsForm) && insuranceFormControl['email'].errors?.['required'])">
                                    Email id is required.
                                </Span>
                            </div>
                            <div class="col-12 position-relative" [ngClass]="{'mb-2':((insuranceFormControl['whatsAppNumber'].touched  || submittedInsForm) && !insuranceFormControl['whatsAppNumber'].valid)}">
                                <input type="text" id="whatsAppNumber" name="whatsAppNumber" placeholder=" " class="form-control input_ tp" formControlName="whatsAppNumber" (keypress)="alphabetOnly($event)"
                                [ngClass]="{'border border-danger': ((insuranceFormControl['whatsAppNumber'].touched  || submittedInsForm) && insuranceFormControl['whatsAppNumber'].errors?.['required'])}"  [readOnly]="true">
                                <label for="whatsAppNumber" class="label_">whatsApp Number</label>
                                <Span class="text-danger error_span" *ngIf="((insuranceFormControl['whatsAppNumber'].touched  || submittedInsForm) && insuranceFormControl['whatsAppNumber'].errors?.['required'])">
                                    whatsApp number is required.
                                </Span>
                            </div>
                            <div class="col-12 position-relative" [ngClass]="{'mb-2':((insuranceFormControl['address'].touched  || submittedInsForm) && !insuranceFormControl['address'].valid)}">
                                <textarea id="address"  rows="5" name="address" placeholder=" " class="form-control input_ tp" formControlName="address" (keypress)="alphabetOnly($event)"
                                [ngClass]="{'border border-danger': ((insuranceFormControl['address'].touched  || submittedInsForm) && insuranceFormControl['address'].errors?.['required'])}" [readOnly]="true"></textarea>
                                <label for="address" class="label_ ta5">Address</label>
                                <Span class="text-danger error_span" *ngIf="((insuranceFormControl['address'].touched  || submittedInsForm) && insuranceFormControl['address'].errors?.['required'])">
                                    Address number is required.
                                </Span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-8">
                <div class="box_header pb-0">
                    <span class="box_title_18">
                        Provider Status
                    </span>           
                </div>
                <div class="p-lr-10">
                    <label class="box_title_18 border_top_grey5 w-100 mb-0 pb-2"></label> 
                    <div class="row">
                        <ng-container *ngFor="let product of insuranceStatus">
                            <div class="col-md-6 mb-2">                                
                                <div class="card min-h-102">
                                    <div class="d-flex py-1 px-2 justify-content-between border-bottom align-items-center">
                                        <div>
                                            <img src="/assets/images/insurance_product/P_30X20_{{product.productId}}.svg">
                                            <span class="ml-2">{{product.productName}}</span>
                                        </div>
                                        <app-toggle-switch [isDisabled]="true" [switchon]="product.status??false" class="toggle-switch"></app-toggle-switch>
                                    </div>
                                    <div class="plan-container px-2 pt-3">
                                        <div class="w-100 position-static">
                                            <app-multi-dropdown  class="w-100 input_"
                                                [items]="product.insuranceProductsPlanListItemObj??[]" 
                                                [showSearch]="true" 
                                                [showAll]="true" 
                                                [showStatus]="false"
                                                [showError]="false" 
                                                placeholder="Plan" 
                                                [isReadOnly]="true"
                                                className=""
                                                ddlClassName = "position-static"
                                                fontColor="var(--grey3)"
                                                fontSize="15px"
                                                id="InsurancePlans_{{product.productId}}"
                                                (itemChange)="onInsuranceCopanyPlanSelect()">
                                            </app-multi-dropdown>
                                            <label class="label_">Plan Configuration</label>
                                        </div>
                                        <ng-container *ngFor="let plan2 of product.insuranceProductsPlanList">
                                            <label>{{plan2.planDescription}}</label>
                                        </ng-container>
                                    </div>                                                                       
                                </div>
                            </div>
                        </ng-container>
                    </div>  
                </div>  
            </div>
        </div>
    </div>
    </app-mainscreen>